module.exports = __webpack_public_path__ + "img/duplicate.6ea01938.svg";